import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider, ThemeProvider } from './contexts'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './lib/queryClient'
import App from './App'
import 'leaflet/dist/leaflet.css'
import './index.css'

// Pages load as separate chunks. After a deploy, a tab still running the old
// build asks for chunk files that no longer exist - reload once to pick up the
// new build instead of leaving the page stuck. The timestamp guard stops a
// reload loop if the chunk is genuinely unreachable (e.g. offline).
window.addEventListener('vite:preloadError', (event) => {
  const key = 'raven-chunk-reload'
  let last = 0
  try { last = Number(sessionStorage.getItem(key)) || 0 } catch { /* storage blocked */ }
  if (Date.now() - last < 10000) return
  try { sessionStorage.setItem(key, String(Date.now())) } catch { /* storage blocked */ }
  event.preventDefault()
  window.location.reload()
})

// Note: StrictMode removed due to Supabase Web Locks API conflicts
// See: https://github.com/supabase/supabase-js/issues/870
ReactDOM.createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </QueryClientProvider>,
)
